import React from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  AUTHENTICATED_ENTRY,
  KITCHEN_AUTHENTICATED_ENTRY,
  VENDOR_AUTHENTICATED_ENTRY,
} from "configs/AppConfig";
import { protectedRoutes, publicRoutes } from "configs/RoutesConfig";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import AppRoute from "./AppRoute";
import { customerType } from "constants/CustomerTypeConstant";

const Routes = () => {
  const { permissions: userPermissions, type } = useSelector(
    (state) => state.auth,
  );

  const roleRouteMap = {
    [customerType.Vendor]: VENDOR_AUTHENTICATED_ENTRY,
    [customerType.Kitchen]: KITCHEN_AUTHENTICATED_ENTRY,
  };

  const roleBasedDestination = roleRouteMap[type] ?? AUTHENTICATED_ENTRY;

  const renderRoutes = (routes) => {
    return routes.map((route) => {
      const Element = (
        <AppRoute
          routeKey={route.key}
          component={route.component}
          {...route.meta}
        />
      );

      if (route.children) {
        return (
          <Route key={route.key} path={route.path} element={Element}>
            {renderRoutes(route.children)}
          </Route>
        );
      }

      return <Route key={route.key} path={route.path} element={Element} />;
    });
  };

  return (
    <RouterRoutes>
      <Route path="/" element={<ProtectedRoute />}>
        <Route
          path="/"
          element={<Navigate replace to={roleBasedDestination} />}
        />
        {protectedRoutes
          .filter(
            (a) =>
              (userPermissions && userPermissions.includes(a.permissions)) ||
              a.permissions === undefined,
          )
          .map((route, index) => {
            return (
              <Route
                key={route.key + index}
                path={route.path}
                element={
                  <AppRoute
                    routeKey={route.key}
                    component={route.component}
                    {...route.meta}
                  />
                }
              />
            );
          })}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
      <Route path="/" element={<PublicRoute />}>
        {/* {publicRoutes.map((route) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })} */}
        {renderRoutes(publicRoutes)}
      </Route>
    </RouterRoutes>
  );
};

export default Routes;
